import { HistoricalSwitch } from 'api/models/Deliveries';
import { OrdersFilters, OrdersSortField } from 'api/models/Orders';
import { SortOrder } from 'api/models/Sorting';
import { atom, useAtom } from 'jotai';

export const PAST_ORDERS_INITIAL_FILTERS: OrdersFilters = {
  sort_order: SortOrder.Ascending,
  sort_by: OrdersSortField.SurgeryDate,
  historical: HistoricalSwitch.Inactive,
};

const pastOrdersFiltersAtom = atom(PAST_ORDERS_INITIAL_FILTERS);

export const usePastOrdersFilters = () => useAtom(pastOrdersFiltersAtom);
